/**
 * Created by guga on 8/4/2016.
 */

export function isValidValue(value : any) : boolean {
    return (value !== undefined && value !== null);
}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/sas/valid-value-check.ts